module.exports = __webpack_public_path__ + "static/media/offer_page_bg.6357b3f4.png";